import React from "react";

import classes from "./CorgiSwim.module.css";

const CorgiSwim = () => {
    return (
        <div className={classes.CorgiSwim}>
            <img src="https://firebasestorage.googleapis.com/v0/b/randomdraftleague-f6d6d.appspot.com/o/giphy.gif?alt=media&token=335e4c0d-b7a9-43a4-91a6-6702e4dbb153" alt="Swimming Corgi" />
        </div>
    );
}

export default CorgiSwim;